// ========================================
// Widget: RRHH — KPI Plantilla Activa
// Proporción progresiva de información según el espacio de columnas (Span 1, 2 o 3)
// ========================================

window.DashboardWidgets = window.DashboardWidgets || {};
window.DashboardWidgets.rrhh = window.DashboardWidgets.rrhh || {};

window.DashboardWidgets.rrhh.kpiTile = function(ctx) {
    const { id, span = 1, controls, displayStyle, isEditMode, activeProfs = [], upcomingHires = [] } = ctx;

    const sanitize = (text) => typeof Utils !== 'undefined' ? Utils.sanitizeHTML(text) : text;

    // ── WIDGET: KPI PLANTILLA ACTIVA ──
    if (id === 'kpi-plantilla') {
        const activeCount = activeProfs.length;
        const upcomingCount = upcomingHires.length;

        // Especialidades
        const specialtyMap = {};
        // Solo quien está de alta hoy, igual que la tarjeta «Plantilla» del panel.
        activeProfs.forEach(p => {
            const spec = (p.specialty && p.specialty.trim()) ? p.specialty.trim() : 'Sin especialidad';
            specialtyMap[spec] = (specialtyMap[spec] || 0) + 1;
        });
        const topSpecs = Object.entries(specialtyMap).sort((a, b) => b[1] - a[1]);

        // 1 HUECO (1 COLUMNA): MÍNIMA INFORMACIÓN / ULTRA LIMPIO Y COMPACTO
        const renderSpan1 = () => `
            <div class="dnr-kpi-top">
                <span class="dnr-kpi-label"><span class="dnr-kpi-icon" style="--dnr-widget-hue:340;"><i class="fas fa-user-tie"></i></span>Plantilla Activa</span>
            </div>
            <div class="dnr-kpi-value">${activeCount}</div>
            <div class="dnr-kpi-sub">Personal de alta hoy</div>
            <div class="dnr-reveal d-flex" style="gap: 4px; margin-top: 0.75rem;">
                ${Array.from({ length: 16 }).map((_, i) => `<div style="width: 7px; height: 7px; border-radius: 50%; background: ${i < Math.min(16, activeCount) ? 'oklch(48% 0.15 340)' : 'var(--dnr-line)'};"></div>`).join('')}
            </div>
        `;

        // 2 HUECOS (2 COLUMNAS): INFORMACIÓN INTERMEDIA (SUMA BADGES + ÁREAS PRINCIPALES)
        const renderSpan2 = () => `
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1.25rem; align-items: flex-start; width: 100%;">
                <div>
                    <div class="dnr-kpi-top">
                        <span class="dnr-kpi-label"><span class="dnr-kpi-icon" style="--dnr-widget-hue:340;"><i class="fas fa-user-tie"></i></span>Plantilla Activa</span>
                    </div>
                    <div style="display: flex; align-items: center; gap: 0.75rem; margin-top: 0.25rem;">
                        <div class="dnr-kpi-value" style="font-size: 2.75rem; line-height: 1;">${activeCount}</div>
                        <div style="display: flex; flex-direction: column; gap: 3px;">
                            <span style="font-size: 0.7rem; font-weight: 700; color: #0f766e; background: rgba(13,148,136,0.1); padding: 2px 7px; border-radius: 4px; white-space: nowrap;">
                                ${upcomingCount} Próximas Altas
                            </span>
                        </div>
                    </div>
                    <div class="dnr-kpi-sub" style="margin-top: 0.5rem;">Personal de alta hoy</div>
                </div>

                <div style="border-left: 1px solid var(--dnr-line); padding-left: 1.25rem;">
                    <div style="font-size: 0.7rem; font-weight: 800; text-transform: uppercase; color: var(--dnr-ink-faint); margin-bottom: 0.5rem; letter-spacing: 0.04em;">
                        Áreas Principales
                    </div>
                    <div style="display: flex; flex-direction: column; gap: 0.4rem;">
                        ${topSpecs.slice(0, 2).map(([spec, count]) => `
                            <div style="display: flex; align-items: center; justify-content: space-between; font-size: 0.75rem;">
                                <span style="color: var(--dnr-ink); font-weight: 600;">${sanitize(spec)}</span>
                                <span style="font-weight: 700; color: var(--dnr-teal-600); background: rgba(13,148,136,0.08); padding: 1px 6px; border-radius: 4px;">${count}</span>
                            </div>
                        `).join('')}
                    </div>
                </div>
            </div>
        `;

        // 3 HUECOS (3 COLUMNAS): INFORMACIÓN COMPLETA Y DETALLADA (KPI + ESPECIALIDADES EXTENDIDAS + ROSTER DE PRÓXIMAS ALTAS)
        const renderSpan3 = () => `
            <div style="display: grid; grid-template-columns: 1fr 1.1fr 1.2fr; gap: 1.5rem; align-items: flex-start; width: 100%;">
                <!-- Columna 1: KPI Principal y Badges -->
                <div>
                    <div class="dnr-kpi-top">
                        <span class="dnr-kpi-label"><span class="dnr-kpi-icon" style="--dnr-widget-hue:340;"><i class="fas fa-user-tie"></i></span>Plantilla Escolar Global</span>
                    </div>
                    <div style="display: flex; align-items: center; gap: 0.85rem; margin-top: 0.25rem;">
                        <div class="dnr-kpi-value" style="font-size: 3rem; line-height: 1;">${activeCount}</div>
                        <div style="display: flex; flex-direction: column; gap: 3px;">
                            <span style="font-size: 0.725rem; font-weight: 700; color: #0f766e; background: rgba(13,148,136,0.1); padding: 3px 8px; border-radius: 6px; white-space: nowrap;">
                                ${upcomingCount} Próximas Incorporaciones
                            </span>
                        </div>
                    </div>
                    <div class="dnr-kpi-sub" style="margin-top: 0.5rem;">Personal de alta hoy</div>
                </div>

                <!-- Columna 2: Desglose Completo de Especialidades Formativas -->
                <div style="border-left: 1px solid var(--dnr-line); padding-left: 1.25rem;">
                    <div style="font-size: 0.7rem; font-weight: 800; text-transform: uppercase; color: var(--dnr-ink-faint); margin-bottom: 0.5rem; letter-spacing: 0.04em;">
                        Especialidades Formativas (${Object.keys(specialtyMap).length})
                    </div>
                    <div style="display: flex; flex-direction: column; gap: 0.45rem;">
                        ${topSpecs.slice(0, 3).map(([spec, count]) => {
                            const pct = Math.round((count / (activeCount || 1)) * 100);
                            return `
                                <div>
                                    <div style="display: flex; justify-content: space-between; font-size: 0.725rem; margin-bottom: 2px;">
                                        <span style="font-weight: 600; color: var(--dnr-ink);">${sanitize(spec)}</span>
                                        <span style="font-weight: 700; color: var(--dnr-ink-mute);">${count} (${pct}%)</span>
                                    </div>
                                    <div style="height: 5px; background: var(--dnr-line); border-radius: 4px; overflow: hidden;">
                                        <div style="height: 100%; width: ${pct}%; background: oklch(48% 0.15 340); border-radius: 4px;"></div>
                                    </div>
                                </div>
                            `;
                        }).join('')}
                    </div>
                </div>

                <!-- Columna 3: Roster de Próximas Altas Programadas -->
                <div style="border-left: 1px solid var(--dnr-line); padding-left: 1.25rem;">
                    <div style="font-size: 0.7rem; font-weight: 800; text-transform: uppercase; color: var(--dnr-ink-faint); margin-bottom: 0.5rem; letter-spacing: 0.04em;">
                        Próximas Altas Programadas
                    </div>
                    ${upcomingHires.length > 0 ? `
                        <div style="display: flex; flex-direction: column; gap: 0.4rem;">
                            ${upcomingHires.slice(0, 2).map(p => {
                                const name = `${p.firstName || ''} ${p.lastName || ''}`.trim() || p.name;
                                const dateStr = p.hireDate ? new Date(p.hireDate + 'T00:00:00').toLocaleDateString('es-ES', { day: 'numeric', month: 'short' }) : 'Próximamente';
                                return `
                                    <div style="display: flex; align-items: center; justify-content: space-between; font-size: 0.75rem; background: var(--dnr-surface-sunken, #f8fafc); border: 1px solid var(--dnr-line); padding: 0.4rem 0.6rem; border-radius: 6px;">
                                        <span style="font-weight: 600; color: var(--dnr-ink); text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">${sanitize(name)}</span>
                                        <span style="font-size: 0.685rem; font-weight: 700; color: var(--dnr-teal-700); background: rgba(13,148,136,0.1); padding: 1px 6px; border-radius: 4px; flex-shrink: 0;">${dateStr}</span>
                                    </div>
                                `;
                            }).join('')}
                        </div>
                    ` : `
                        <div style="font-size: 0.75rem; color: var(--dnr-ink-faint); font-style: italic; background: var(--dnr-surface-sunken, #f8fafc); border: 1px dashed var(--dnr-line); padding: 0.5rem; border-radius: 6px; text-align: center;">
                            Sin altas futuras programadas
                        </div>
                    `}
                </div>
            </div>
        `;

        let content = renderSpan1();
        if (span === 2) content = renderSpan2();
        if (span === 3) content = renderSpan3();

        return `
            <div id="widget-${id}" data-widget-id="${id}" draggable="${isEditMode ? 'true' : 'false'}" class="dnr-card dashboard-widget-card ${isEditMode ? 'edit-mode' : 'dnr-clickable'}" style="grid-column: span ${span}; min-width: 0; display: ${displayStyle}; flex-direction: column; cursor: ${isEditMode ? 'grab' : 'pointer'}; position: relative; border: ${isEditMode ? '2px dashed var(--dnr-teal-500)' : '1px solid var(--dnr-line)'}; padding: 1.15rem 1.35rem;" ${isEditMode ? '' : `${UIEvents.attr("click", function(event,captured){App.navigate('profesores');}, [])}`}>
                ${controls}
                ${content}
            </div>`;
    }

    return '';
};
